import { storeToRefs } from 'pinia'
import { useOrganizationsStore } from '~/store/organizations'
import { useWorkspacesStore } from '~/store/workspaces'

export const getOrganizationRoutePath = (routePath?: string) => {
  const organizationStore = useOrganizationsStore()
  const { selectedOrganization } = storeToRefs(organizationStore)

  if (!selectedOrganization.value) return ''

  return `/o/${selectedOrganization.value.urlPath}${routePath ?? ''}`
}

export const getWorkspaceRoutePath = (routePath?: string) => {
  const workspacesStore = useWorkspacesStore()
  const { selectedWorkspace } = storeToRefs(workspacesStore)

  if (!selectedWorkspace.value) return ''

  return getOrganizationRoutePath(
    `/${selectedWorkspace.value.workspace.urlPath}${routePath ?? ''}`,
  )
}
